import { useState, useEffect } from 'react';
import Notification from '../interfaces/Notification';
import { getByImsClose, getImsCloseList } from '../Notification.service';
import GridComponent from '../../../component/grid/GridComponent.component';
import ButtonBack from '../../../component/buttton/ButtonBack.component';
import ParamTypes from '../../../core/interfaces/ParamTypes';
import { useParams } from 'react-router-dom';
import Progress from '../../../component/progress/Progress.component';
import { INITIAL_VALUES } from '../utils/INITIAL_VALUES';
import { useSnackbar } from '../../../context/Snackbar';
import { FormInput } from '../../../component/input/InputStyle';
import FormLabel from '../../../component/input/FormLabel.component';
import { Form } from '../../../component/form/Form';
import FormInDiagnosis from '../form/FormInDiagnosis.component';
import FormInResolution from '../form/FormInResolution.component';
import FormSolved from '../form/FormSolved.component';
import Card from '../../../component/card/Card.component';

export default function CloseViewNotification() {

    let { id } = useParams<ParamTypes>();
    const { setSnackbar } = useSnackbar();
    const [notificationClosed, setNotificationClosed] = useState<Notification[]>([]);
    const [notification, setNotification] = useState<Notification>(INITIAL_VALUES);
    const [request, setRequest] = useState(true);

    useEffect(() => {
        getImsCloseList(Number(id)).then(res => {
            if (res.data) {
                setNotificationClosed(res.data);
            }
        }).catch((error) => {
            console.log('Erro ao consultar notificação IMs fechadas!', error);
            setSnackbar({ msg: "Erro ao consultar notificações IMs fechadas!", type: 'error' });
        }).finally(function () {
            setRequest(false)
        });
    }, [id, setSnackbar]);

    useEffect(() => {
        getByImsClose(Number(id)).then(res => {
            if (res.data) {
                setNotification(res.data[0]);
            }
        }).catch((error) => {
            console.log('Erro ao consultar notificação!', error);
            setSnackbar({ msg: "Erro ao consultar notificação!", type: 'error' });
        }).finally(function () {
            setRequest(false)
        });
    }, [id, setSnackbar]);

    if (request) {
        return <Progress open={request} />
    }


    return (
        <>
            <ButtonBack to='/notificacao/notificacoes-fechadas' />

            {notificationClosed.map((notificationClosed: Notification, index: number) => {

                return (
                    <Card key={index} margin="30px 0px">
                        <Form >
                            <GridComponent justify="flex-start" alignItems="center" spacing={2} margin="30px 0px 30px 0px">
                                <FormLabel title="Título" md={3}>
                                    <FormInput value={notification.title} disabled />
                                </FormLabel>
                                <FormLabel title="TICKET" md={3}>
                                    <FormInput value={notification.ticket} disabled />
                                </FormLabel>
                                <FormLabel title="SERVIÇO AFETADO INICIAL" md={3}>
                                    <FormInput value={notification.initialAffectedService} disabled />
                                </FormLabel>
                                <FormLabel title="status" md={3}>
                                    <FormInput value={notificationClosed.type} disabled />
                                </FormLabel>

                                {notificationClosed.type === 'DIAGNOSIS' &&
                                    <FormInDiagnosis initialValues={notificationClosed} disabled={true} />
                                }

                                {notificationClosed.type === 'RESOLUTION' &&
                                    <FormInResolution initialValues={notificationClosed} disabled={true} />
                                }
                                {notificationClosed.type === 'SOLVED' &&
                                    <FormSolved initialValues={notificationClosed} disabled={true} />
                                }
                            </GridComponent>
                        </Form>
                    </Card>
                )
            })}
        </>
    );
}
